module.exports = __webpack_public_path__ + "img/2.2d7e3f1.png";